var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoDurafloorHw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 210 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#F4F4F5;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3,32.42h9.31c4.83,0,10-2,10-8.8s-5.14-8.8-10-8.8H6.9V28.71H3V11.05h9.46c7.18,0,13.84,3.92,13.84,12.57S19.67,36.18,12.49,36.18H3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M30.78,25.45V11.05h3.91V25.39c0,4.79,2.9,7.63,7.59,7.63s7.58-2.84,7.58-7.63V11.05h3.91v14.4c0,7-5,11.3-11.5,11.3s-11.5-4.27-11.5-11.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M59.59,11.05h3.87v4.83c1.62-3.1,4.68-4.93,8.9-4.93v4c-4.53-.1-8.9,2.44-8.9,9.31v12H59.59Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M74.5,23.62a13.09,13.09,0,0,1,13-13.13,11.94,11.94,0,0,1,9.72,4.58v-4h3.86V36.18H97.19v-4a11.94,11.94,0,0,1-9.72,4.58,13.08,13.08,0,0,1-13-13.12m22.63,0a9,9,0,0,0-8.74-9.31h-.57a9.31,9.31,0,1,0,9.31,9.31h0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M107.43,9.93c0-6.46,4.68-9.51,11.29-8.65V4.79c-4.78-.66-7.43,1-7.43,5.2v1.06H118v3.51h-6.67V36.19h-3.86Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M126.47,1.64v28c0,3.25,2.7,4,5.55,2.95v3.56c-4.94,1.37-9.42-.76-9.42-6.16V1.64Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M133.64,23.62a13.2,13.2,0,1,1,13.28,13.12h-.1a13.11,13.11,0,0,1-13.18-13v-.1m22.39,0a9.19,9.19,0,1,0-9.21,9.25A9.05,9.05,0,0,0,156,24v-.35"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M163.3,23.62a13.2,13.2,0,1,1,13.27,13.12h-.09a13.09,13.09,0,0,1-13.18-13v-.1m22.39,0a9.19,9.19,0,1,0-9.21,9.25,9.06,9.06,0,0,0,9.21-8.9v-.35"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M194.2,11.05h3.87v4.83c1.63-3.1,4.68-4.93,8.9-4.93v4c-4.53-.1-8.9,2.44-8.9,9.31v12h-3.86Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDurafloorHw);
export default __webpack_public_path__ + "static/media/logo-durafloor-hw.0dea3cf9ac95ca593198306ee2e0bdd7.svg";
export { ForwardRef as ReactComponent };